/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_CrumbInputs */

const en_onboarding_crumb = /** @type {(inputs: Onboarding_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onboarding`)
};

const pl_onboarding_crumb = /** @type {(inputs: Onboarding_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdrożenie`)
};

/**
* | output |
* | --- |
* | "Onboarding" |
*
* @param {Onboarding_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const onboarding_crumb = /** @type {((inputs?: Onboarding_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_onboarding_crumb(inputs)
	return en_onboarding_crumb(inputs)
});